module.exports = __webpack_public_path__ + "static/media/Davis Project for Peace.29a15989.png";